export const importExportAcions = [
  {
    name: 'exportCollectionItem',
    label: 'Export Collection Item',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'filterId',
        label: 'Select Filter',
        type: 'dropdown',
        optionsType: 'filterApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'importCollectionItem',
    label: 'Import Collection Item',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
